<h2>TSA Security Threat History
        <button *ngIf="showHistoryEnabled" class="icon--history btn--default" (click)="showHistory()" type="button">View History</button>
</h2>
<p-table [value]="filteredHistory">
    <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="editorEnabled ? 6 : 5">
                No Records Found
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th>Response</th>
            <th class="w--date">Response Date</th>
            <th class="w--date">Expiration Date</th>
            <th>Updated By</th>
            <th class="w--date">Updated Date</th>
            <th *ngIf="editorEnabled" class="w--icon">Delete</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-data>
        <tr [pSelectableRow]="data">
            <td>{{ data.driverTSASecurityThreatTypeDisplayValue }}</td>
            <td>{{ data.receivedDate | date:'M/d/yyyy' }}</td>
            <td>{{ data.expirationDate | date:'M/d/yyyy' }}</td>
            <td>{{ data.updatedBy }}</td>
            <td>{{ data.updatedDate | date:'M/d/yyyy' }}</td>
            <td *ngIf="editorEnabled" class="text-center"><a *ngIf="hasDeletePrivilege" href="javascript:void(0)" class="icon--delete" title="Delete"(click)="openDeleteConfirmationModal(data)"></a></td>
        </tr>
    </ng-template>
</p-table>